module.exports = __webpack_public_path__ + "static/media/Cosmog_gaussian2.6fba93d8.png";